import { SvgIcon as MuiSvgIcon } from '@mui/material';
import { styled } from '@mui/material/styles';

/**
 * Styled SvgIcon that respects SVG presentation attributes.
 *
 * MUI's default SvgIcon applies `fill: currentColor` via CSS, which overrides
 * inline SVG attributes like fill="none" (CSS has higher specificity than
 * presentation attributes).
 *
 * This styled version:
 * - Sets fill: none to prevent CSS from overriding SVG fill attributes
 * - Sets stroke: currentColor to enable stroke-based icon theming
 * - Works with both stroke-based (fill="none") and fill-based (fill="currentColor") icons
 *
 * Usage:
 * - Stroke-based icons (fill="none" + stroke="currentColor" in SVG): stroke gets theme color
 * - Fill-based icons (fill="currentColor" in SVG): SVG inline attribute overrides CSS fill: none
 */
export const StyledSvgIcon = styled(MuiSvgIcon)({
  fill: 'none',
}) as unknown as typeof MuiSvgIcon;
